import { memo, useEffect } from 'react'

import isYoutube from './YouTubeEmbed/helpers/isYoutube'
import OEmbedHtml from './OEmbedHtml'
import YouTubeEmbed from './YouTubeEmbed'
import { TLinkPreview } from './types'
import useIsPausedInput from './useIsPausedInput'
import FullImagePreview from './FullImagePreview'
import GeneralLinkPreview from './GeneralLinkPreview'
import { useLazyGetApiV1LinksQuery } from './api'

const LinkPreview = memo(
  ({
    text,
    url: inputUrl,
    onClose,
    showImage,
    isFocusedField,
    card: postCard,
  }: TLinkPreview) => {
    const [getLinkPreview, { data, originalArgs }] = useLazyGetApiV1LinksQuery()

    const card = postCard || data
    const url = inputUrl || card?.url || ''

    const isYoutubeUrl = url && isYoutube(url)
    const embedHtml = card?.oembedHtml || data?.oembedHtml

    const validLink = url?.startsWith('http') ? url : `https://${url}`
    const isSameLink =
      originalArgs?.url === validLink || postCard?.url === inputUrl
    const isPausedInput = useIsPausedInput(text || '', 3000)

    const canFetchPreview =
      url && !isSameLink && (!isFocusedField || isPausedInput) && !card

    useEffect(() => {
      canFetchPreview && void getLinkPreview({ url: validLink })
    }, [canFetchPreview])

    const isImageFile = Boolean(!card?.publisher && card?.image && card?.url)

    switch (true) {
      case isYoutubeUrl:
        return <YouTubeEmbed url={url} />
      case !!embedHtml:
        return <OEmbedHtml code={embedHtml} />
      case isImageFile:
        return (
          <FullImagePreview
            url={card?.url as string}
            image={card?.image as string}
          />
        )
      case !!card:
        return (
          <GeneralLinkPreview
            card={card}
            onClose={onClose}
            showImage={showImage}
          />
        )
      default:
        return null
    }
  },
)

export default LinkPreview

LinkPreview.displayName = 'LinkPreview'
